<div class="modal-body text-center">
  <p [innerHTML]="text"></p>
  <button type="button" class="btn btn-primary" (click)="submitBulletinsModalConfirm()">{{ "bulletins.table.submitBulletinsDialog.accept" | translate }}</button>
  <button type="button" class="btn btn-default" (click)="submitBulletinsModalDecline()">{{ "bulletins.table.submitBulletinsDialog.reject" | translate }}</button>
</div>
